import {MediaQuery} from '@services/MediaQuery'
import anime, {AnimeInstance} from 'animejs'

import {ConnectedComponent} from 'lowkey-component'
import {createApplicationState} from '@services/ApplicationState'

export class FirstViewScroll extends ConnectedComponent<HTMLDivElement> {
  mq = MediaQuery.create()
  observer: IntersectionObserver | null = null
  private appState = createApplicationState()
  private upAnime: AnimeInstance | null = null
  private downAnime: AnimeInstance | null = null

  constructor(element: HTMLDivElement) {
    super(element)
    this.onIntersection = this.onIntersection.bind(this)
  }

  didMount() {
    if (this.mq.isPhone()) {
      return
    }
    this.observer = new IntersectionObserver(this.onIntersection, {
      rootMargin: '0px',
      threshold: [1],
    })
    this.observer.observe(this.element)
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      if (entry.intersectionRatio === 1) {
        this.disable()
      } else {
        this.enable()
      }
    }
  }

  enable() {
    this.appState.updateOneViewStatus('down')
    this.appState.updateOneViewStatus('downComplete')
    this.upAnime?.pause()
    this.downAnime = anime({
      duration: 500,
      easing: 'easeOutCirc',
      opacity: 0,
      targets: this.element,
      complete: () => {
        this.element.style.pointerEvents = 'none'
      }
    })
  }

  disable() {
    this.appState.updateOneViewStatus('up')
    this.downAnime?.pause()
    this.upAnime = anime({
      duration: 500,
      easing: 'easeOutCubic',
      opacity: 1,
      targets: this.element,
      complete: () => {
        this.element.style.pointerEvents = 'auto'
        this.appState.updateOneViewStatus('upComplete')
      }
    })

  }
}
